<ng-template appShowpopup></ng-template>
<header class="fixed top-0 z-30 w-full px-6 py-3 bg-header_bg shadow h-[var(--header-h)]">
    <div class="sm:flex items-center justify-between">
        <a routerLink="/main" *ngIf="loginUser?.userRole=='CANDIDATE'">
            <img class="w-36" [src]="_commonServices.Images.LOGO_NEW_HEADER" alt=""/>
        </a>
        <img class="w-44" [src]="_commonServices.Images.LOGO_NEW_HEADER" alt="" *ngIf="loginUser?.userRole=='FRACTAL_ADMIN' || loginUser?.userRole=='FRACTAL_HR' || loginUser?.userRole=='COLLEGE_ADMIN' || loginUser?.userRole=='CLIENT_HR' ">
        <div class="flex gap-4 items-center">
            
            <div *ngIf="loginUser?.userRole=='FRACTAL_ADMIN' && canSeeProctoringServer()"
                (click)="navToProctoringServer()" title="Video Proctoring Server">
                <img [src]="_commonServices.Images.USER_PROCTORING_ICON" alt="proctoring server" class="cursor-pointer w-8 h-8 object-contain">
            </div>
            
            <div *ngIf="loginUser?.userRole=='FRACTAL_ADMIN'" (click)="navToServerHealthCheck()">
                <img [src]="_commonServices.Images.SERVER_ICON" alt="report" class="cursor-pointer w-8 h-8">
            </div>

            <div *ngIf="loginUser?.userRole=='FRACTAL_ADMIN'" (click)="navToReportedQuestion()">
                <img [src]="_commonServices.Images.QUESTION_MARK_WITH_RED_ICON" alt="report" class="cursor-pointer w-8 h-8">
            </div>

             <div *ngIf="(loginUser?.userRole == 'FRACTAL_HR' || loginUser?.userRole == 'CLIENT_HR') && _permissionServices.can(P.INVITED_USERS)">
                <img (click)="routeToWorkdayFailures()" [src]="_commonServices.Images.QUESTION_MARK_WITH_RED_ICON" alt="alert" class="-mt-[0.1rem] w-8 h-8 cursor-pointer">
            </div>

            <div>
                <img [src]="_commonServices.Images.NOTIFICATION_ICON2" alt="notification" class="my-auto">
            </div>

            <div class="flex gap-2 items-center">
                <div *ngIf="loginUser?.userRole == 'CANDIDATE'">
                    <img [src]="loginUser.profilePicture?.filePreviewUrl ? loginUser.profilePicture.filePreviewUrl : _commonServices.Images.AVATAR"   alt="avatar" class="h-10 w-10 rounded-full" >
                </div>
                <div *ngIf="loginUser?.userRole == 'FRACTAL_ADMIN' ||  loginUser?.userRole == 'FRACTAL_HR' || loginUser?.userRole=='COLLEGE_ADMIN' || loginUser?.userRole=='CLIENT_HR' " class="h-8 w-8 rounded-full bg-header_admin_blue_color flex items-center justify-center text-white">
                    {{loginUser?.fullName.slice(0,1)}}
                  <!-- <img [src]="_commonServices.Images.ADMIN_HR_PROFILE_IMAGE"   alt="avatar" class="h-8 w-8" > -->
                   <!-- <img [src]="_commonServices.Images.AVATAR"   alt="avatar" class="h-8 w-8" > -->
              </div>
                <div>
                    <div class="flex  cursor-pointer gap-3" (click)="togglePopup()" #dropdownElement appOutsideClick
                        (appOutsideClick)="closeDropdown()">
                        <h1 class="text-primary_Text_Color xs:text-xxs sm:text-sm my-auto poppinsSemiBold classForAvoidHostListener">
                            {{loginUser?.fullName==null ? 'N/A' : loginUser?.fullName.length>25 ?
                            (loginUser?.fullName | slice:0:25)+ "..." : loginUser?.fullName}}</h1>
                        <img [src]="_commonServices.Images.COUNTRY_DROPDOWN" alt=""
                            [ngClass]="{'transform rotate-180':isOpen}"
                            class="transition-transform duration-200 classForAvoidHostListener w-3">
                    </div>
                    <div>
                        <p class="text-xs text-dark_blue_60 poppinsMedium">  {{ 
                            loginUser?.userRole === 'FRACTAL_ADMIN' 
                              ? 'Admin' 
                              : loginUser?.userRole === 'COLLEGE_ADMIN' 
                              ? 'College Admin' 
                              : 'HR' 
                          }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="isOpen">
        <div class=" absolute bg-white  rounded-lg border-gray-300 border
        shadow mt-1 right-5 top-16 p-4">
            <div class="flex gap-2">
                <div>
                    <img [src]="_commonServices.Images.AVATAR" alt="avatar" class="h-8 w-8 mt-2">
                </div>
                <div>
                    <div class="flex gap-2" (click)="togglePopup()">
                        <h1 class="dashBoradNameText classForAvoidHostListener">
                            {{loginUser?.fullName==null ? 'N/A' : loginUser?.fullName.length>25 ?
                            (loginUser?.fullName | slice:0:25)+ "..." : loginUser?.fullName}}</h1>
                        <p class="mt-1 opacity-50">-</p>
                        <p class="text-xs text-secondary_Light_Text_Color font-medium mt-2">{{ 
                            loginUser?.userRole === 'FRACTAL_ADMIN' 
                              ? 'Admin' 
                              : loginUser?.userRole === 'COLLEGE_ADMIN' 
                              ? 'College Admin' 
                              : 'Hr' 
                          }}</p>
                    </div>
                    <div>
                        <p class="text-xs text-secondary_Light_Text_Color font-medium">{{loginUser.email}}</p>
                    </div>
                </div>
            </div>
            <ul class="mt-3">
                <li *ngIf="loginUser?.userRole != 'COLLEGE_ADMIN'" class="text-text_secondary_gray text-base font-medium cursor-pointer block px-2 py-2 hover:bg-gray-100"
                    routerLinkActive="active" (click)="openChangePasswordPopup()">
                    <div class="flex gap-2">
                            <img [src]="_commonServices.Images.CHANGE_PASSWORD_ICON" alt="change password">
                        <p class="text-sm 2xl:text-base">Change Password</p>
                    </div>
                </li>
                <li class="text-text_secondary_gray text-base font-medium cursor-pointer block px-2 py-2 hover:bg-gray-100"
                    (click)="logOut()" routerLinkActive="active">
                     <div class="flex gap-2">
                         <img [src]="_commonServices.Images.SIGN_OUT_ICON" alt="sign out">
                        <p class="text-sm 2xl:text-base">Sign Out</p>
                     </div>
                </li>
            </ul>
        </div>
    </div>

</header>
